import PropTypes from 'prop-types'
import { gql, useQuery } from 'urql'
import Pill from 'components/Pill'

const DestinationModalContinentList = ({
  pause,
  continentId,
  setContinentId,
}) => {
  const [{ data }] = useQuery({
    query: gql`
      query DestinationModalContinentList ($orderBy: [OrderByClause!]) {
        continents (orderBy: $orderBy) {
          id
          value
        }
      }
    `,
    variables: {
      orderBy: [{
        column: 'VALUE',
        order: 'ASC',
      }],
    },
    pause: pause && typeof window !== 'undefined',
  })

  return (
    <div className="flex gap-14">
      <Pill
        action={() => setContinentId(undefined)}
        text="All"
        isActive={continentId === undefined}
        variant="public"
      />

      {
        data && data?.continents?.map((continent) => (
          <Pill
            key={`continent-pill-${continent.id}`}
            action={() => setContinentId(continentId === continent?.id
              ? undefined
              : continent?.id,
            )}
            text={continent.value}
            isActive={continentId === continent?.id}
            variant="public"
          />
        ))
      }
    </div>
  )
}

DestinationModalContinentList.propTypes = {
  pause: PropTypes.bool,
  continentId: PropTypes.string,
  setContinentId: PropTypes.func,
}

export default DestinationModalContinentList
